import React from 'react';
import { Lightbulb } from 'lucide-react';

const InsightBox = ({ title = 'Insight', children }) => {
  return (
    <div className="relative my-8 bg-gradient-to-br from-courtyard-gold/10 to-courtyard-gold/5 border border-courtyard-gold/25 rounded-2xl p-6 shadow-sm overflow-hidden">
      <div className="absolute top-0 right-0 w-24 h-24 bg-courtyard-gold/5 rounded-bl-full" />
      <div className="relative">
        <div className="flex items-center gap-2.5 mb-3">
          <div className="w-8 h-8 rounded-lg bg-courtyard-gold/20 flex items-center justify-center">
            <Lightbulb className="w-4.5 h-4.5 text-courtyard-gold" aria-hidden="true" />
          </div>
          <h4 className="font-display font-bold text-courtyard-stone text-base">{title}</h4>
        </div>
        <div className="text-[15px] text-courtyard-stone/80 leading-relaxed space-y-2.5 pl-[42px]">
          {children}
        </div>
      </div>
    </div>
  );
};

export default InsightBox;
